import { makeAutoObservable, runInAction } from "mobx";

export default class KeyFeatureStore {
  keyFeatures = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.keyFeatures = [];
    runInAction(() => {
      this.keyFeatures = data;
    });
  };

  deleteItem = (id) => {
    let newState = this.keyFeatures.filter((item) => item.id !== id);
    this.keyFeatures = [];
    this.keyFeatures = newState;
  };
}
